export default __webpack_public_path__ + "static/Cmore-a72b1a22036aa984459cc69154be40f3.webp";